import React from 'react';

import { useTranslation } from 'react-i18next';

import { Button, ButtonIcon } from '@pkg/components/Sections/Profile/Buttons';
import { ReactComponent as FilterIcon } from '@pkg/components/Sections/Profile/icons/icon-filter.svg';

import { FiltersListToggleMobile } from './styles';

export interface FiltersListToggleProps {
    count?: number;
    open?: boolean;
    mobile?: boolean;
    onToggle(): void;
    removeNavigationBottomSpacing?: boolean;
}

export function FiltersListToggle({
    count = 0,
    open = false,
    mobile = false,
    onToggle,
    removeNavigationBottomSpacing,
}: FiltersListToggleProps) {
    const { t: translate } = useTranslation(['yat_nft_manager']);

    const label = translate(open ? 'yat_nft_manager_filters_hide' : 'yat_nft_manager_filters_show');

    return mobile ? (
        <FiltersListToggleMobile $removeNavigationBottomSpacing={removeNavigationBottomSpacing}>
            <ButtonIcon aria-label={label} pulse onClick={onToggle}>
                <FilterIcon />
            </ButtonIcon>
        </FiltersListToggleMobile>
    ) : (
        <Button
            aria-label={label}
            size="small"
            variant="solid"
            color="secondary"
            startIcon={<FilterIcon />}
            onClick={onToggle}
        >
            {`${label} ${count > 0 ? `(${count})` : ''}`}
        </Button>
    );
}
